import { render, staticRenderFns } from "./ContentWeekCalendar.vue?vue&type=template&id=0a5a9a51&"
import script from "./ContentWeekCalendar.vue?vue&type=script&lang=js&"
export * from "./ContentWeekCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports